<app-side-nav-container [title]="currentSite.name"
                        [status]="currentSite.currentStatus"
                        [menu]="navMenu"
                        [userClaims]="this.UserClaims"
                        id='siteSideNavContainer'></app-side-nav-container>
